import React from 'react';
import PropTypes from 'prop-types';


import * as trendDirectionConstants from './trendDirectionConstants';

import {I18nMessage} from '../../I18n';



function TrendDirection({direction}) {

    const labelKey = trendDirectionConstants.TREND_DIRECTION_LABEL_BY_VALUE[direction];

    return (
        <I18nMessage id={`content.trend.direction.${labelKey}`}/>
    );
}


TrendDirection.propTypes = {
    direction: PropTypes.oneOf(trendDirectionConstants.TREND_DIRECTION_VALUES).isRequired
};

TrendDirection.defaultProps = {};


export default TrendDirection;
